var React = require('react');

function CarrotUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 0L8 7H0L4 0Z","fill":"#99CC72"}));
}

CarrotUp.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7","fill":"none"};

module.exports = CarrotUp;

CarrotUp.default = CarrotUp;
